// extracted by mini-css-extract-plugin
export var completionBody = "_hu-2";
export var completionCard = "_hu-0";
export var completionFooter = "_hu-3";
export var completionTitle = "_hu-1";